import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../../@types/RootState';
import { Sort } from '../../../../../@types/sort';

const initialState: Sort<string> = {
  type: 'recurrence.expirationDate',
  orderBy: 'asc',
};

const slice = createSlice({
  name: 'ipa.strategy.rules.table.sort',
  initialState,
  reducers: {
    RESET_RULES_TABLE_SORT: () => initialState,
    SET_RULES_TABLE_SORT: (state, action: PayloadAction<Partial<Sort>>) => {
      return { ...state, ...action.payload };
    },
  },
});

export const selectorRulesPageTableSort = (state: RootState) => {
  return state.ipa.strategy.rules.table.sort;
};

export const { RESET_RULES_TABLE_SORT, SET_RULES_TABLE_SORT } = slice.actions;

export default slice.reducer;
